var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "chat-viewer__info-panel pt-2 pb-2 mt-2 pl-1 pr-1 mb-2 bg-gray-300 font-weight-bold",
    },
    [
      _vm.conversation
        ? _c(
            "div",
            [
              _c("div", { staticClass: "d-flex justify-content-between" }, [
                _c(
                  "div",
                  [
                    _vm.inDoNotContact
                      ? _c(
                          "el-tooltip",
                          {
                            attrs: {
                              effect: "light",
                              content: "Do Not Contact",
                              placement: "top-start",
                            },
                          },
                          [
                            _c("span", { staticClass: "text-danger" }, [
                              _c("i", { staticClass: "fas fa-user-slash" }),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.contactFilemakerId
                      ? _c("span", { staticClass: "contact-filemaker-id" }, [
                          _vm._v(_vm._s(_vm.contactFilemakerId)),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("span", { staticClass: "contact-full-name" }, [
                      _vm._v(_vm._s(_vm._f("uppercase")(_vm.contactFullName))),
                    ]),
                    _vm._v(" "),
                    _c("copy-to-clipboard", {
                      attrs: { value: _vm.contactNameWithFilemakerId },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", [
                  _c("span", { staticClass: "outgoing-number-title" }, [
                    _vm._v(
                      _vm._s(_vm._f("uppercase")(_vm.outgoingNumberTitle))
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "d-flex justify-content-between" }, [
                _c(
                  "div",
                  [
                    _vm.phoneNumberInDoNotContact && !_vm.inDoNotContact
                      ? _c(
                          "el-tooltip",
                          {
                            attrs: {
                              effect: "light",
                              content: "Do Not Contact",
                              placement: "top-start",
                            },
                          },
                          [
                            _c("span", { staticClass: "text-danger" }, [
                              _c("i", { staticClass: "fas fa-user-slash" }),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hasContactPhoneNumber
                      ? [
                          _vm._v("(" + _vm._s(_vm.contactPhoneNumber) + " "),
                          _c("copy-to-clipboard", {
                            attrs: { value: _vm.contactPhoneNumber },
                          }),
                          _vm._v(" )"),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _vm._v(
                      "\n        (" +
                        _vm._s(_vm.outgoingNumberPhoneNumber) +
                        " "
                    ),
                    _c("copy-to-clipboard", {
                      attrs: { value: _vm.outgoingNumberPhoneNumber },
                    }),
                    _vm._v(" )\n      "),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "d-flex justify-content-between" }, [
                _c(
                  "div",
                  [
                    _vm.emailInDoNotContact && !_vm.inDoNotContact
                      ? _c(
                          "el-tooltip",
                          {
                            attrs: {
                              effect: "light",
                              content: "Do not contact",
                              placement: "top-start",
                            },
                          },
                          [
                            _c("span", { staticClass: "text-danger" }, [
                              _c("i", { staticClass: "fas fa-user-slash" }),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hasContactEmail
                      ? [
                          _vm._v("(" + _vm._s(_vm.contactEmail) + " "),
                          _c("copy-to-clipboard", {
                            attrs: { value: _vm.contactEmail },
                          }),
                          _vm._v(" )"),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
                _vm._v(" "),
                _vm.hasEmailAddress
                  ? _c(
                      "div",
                      [
                        _vm._v("\n        (" + _vm._s(_vm.emailAddress) + " "),
                        _c("copy-to-clipboard", {
                          attrs: { value: _vm.emailAddress },
                        }),
                        _vm._v(" )\n      "),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "d-flex justify-content-between" }, [
                _c(
                  "div",
                  { staticClass: "my-1" },
                  [
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content: "Make an outgoing call",
                          effect: "light",
                          placement: "top",
                        },
                      },
                      [
                        _vm.canMakeCall
                          ? _c("outbound-call", {
                              staticClass:
                                "btn btn-success btn_call btn_call-sm",
                              attrs: { conversation: _vm.conversation },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content: "Add to a group",
                          effect: "light",
                          placement: "top",
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "btn btn-secondary btn_call btn_call-sm",
                            staticStyle: { padding: "0.25rem 0.45rem" },
                            on: { click: _vm.showSendListDialog },
                          },
                          [_c("i", { staticClass: "fas fa-users" })]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("conversation-preserve", {
                      attrs: { conversation: _vm.conversation },
                    }),
                    _vm._v(" "),
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content: "Edit contact",
                          effect: "light",
                          placement: "top",
                        },
                      },
                      [
                        _vm.canEditContact
                          ? _c(
                              "span",
                              {
                                staticClass:
                                  "btn btn-secondary btn_call btn_call-sm",
                                staticStyle: { padding: "0.25rem 0.45rem" },
                                on: { click: _vm.onEditContact },
                              },
                              [_c("i", { staticClass: "fas fa-edit" })]
                            )
                          : _vm._e(),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("note-viewer", {
                attrs: {
                  note: _vm.note,
                  "store-note-url": _vm.storeNoteUrl,
                  "read-only-notes": _vm.readOnlyNotes,
                  "can-set-read-only-note": _vm.canSetReadOnly,
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }